import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';

@Component({
    selector: 'app-update-automaker-price-table',
    templateUrl: './update-automaker-price-table.component.html',
    standalone: false
})
export class UpdateAutomakerPriceTableComponent implements OnInit {
  loading = false;
  automakerId: number;
  automaker: AutomakerDto;
  selectedFile: any;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly automakerService: AutomakerService,
    private readonly alertService: AlertService
  ) {}

  selectFile(event: any) {
    this.selectedFile = event.target.files;
    console.log(typeof this.selectedFile);
  }

  redirectToPriceTable() {
    this.router.navigate([`/automakers/${this.automakerId}/prices`]);
  }

  ngOnInit() {
    this.loading = true;
    this.automakerId = this.activatedRoute.snapshot.params['id'];
    this.automakerService
      .findById(this.automakerId)
      .subscribe({
        next: (result) => (this.automaker = result),
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao recuperar as informações' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  submitForm() {
    this.loading = true;
    this.automakerService
      .uploadPriceTable(this.automakerId, this.selectedFile.item(0))
      .subscribe({
        next: () => this.alertService.showAlert({ type: 'success', title: 'Arquivo carregado com sucesso' } as Alert),
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao carregar o arquivo' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  private getFileNameFromHeader(headers: any): string | null {
    const contentDisposition = headers.get('Content-Disposition');
    if (!contentDisposition) return null;

    const matches = /filename="([^"]+)"/.exec(contentDisposition);
    return matches && matches[1] ? matches[1] : null;
  }

  private getFormatedDateTime(): string {
    const agora = new Date();
    const data = agora.toISOString().split('T')[0];
    const hora = agora.getHours().toString().padStart(2, '0') + agora.getMinutes().toString().padStart(2, '0');
    return `${data}_${hora}`;
  }

  downloadModelFile(automakerId: number) {
    this.loading = true;

    this.automakerService
      .downloadModelFile(automakerId)
      .subscribe({
        next: (response) => {
          const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          const nomeBase = this.getFileNameFromHeader(response.headers) || 'CarDealer_Tabela_Preco_Modelo';
          const timestamp = this.getFormatedDateTime();
          a.download = `${nomeBase}_${timestamp}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao baixar o arquivo' } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
